import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { getLogByFieldValue } from "services/mouvementService";
import DataTable from "ui/Tables/DataTable";
import ModuleTitle from "components/ModuleTitle";
import { normalizeText } from "utils/textOperation";
import { NO_DATA_FOUND } from "constant/message";

const PuceLogs = ({ ApiService, numero }) => {
  const [listLogs, setListLogs] = useState([]);
  const [rows, setRows] = useState([]);
  // const [isVisible, setIsVisible] = useState(false);
  const handleSearch = (value) => {
    if (value === "") {
      setRows(listLogs);
    } else {
      const searchTerm = normalizeText(value);

      const filteredData = listLogs.filter((item) => {
        return (
          normalizeText(item?.dateMouvement).includes(searchTerm) ||
          normalizeText(item?.motif).includes(searchTerm) ||
          normalizeText(item?.previousValue).includes(searchTerm) ||
          normalizeText(item?.currentValue).includes(searchTerm) ||
          normalizeText(item?.auteur).includes(searchTerm) ||
          normalizeText(item?.entityItem).includes(searchTerm)
        );
      });
      if (filteredData.length > 0) {
        setRows(filteredData);
        // setIsVisible(true);
      } else {
        const loadData = {
          isAlert: true,
          message: NO_DATA_FOUND,
          isLoading: false,
          alertSeverity: "error",
        };
        ApiService.handleLoad(loadData);
        // setRows([]);
        // setIsVisible(false);
      }
    }
  };
  const fetchLogsData = async () => {
    const fetchData = await getLogByFieldValue(ApiService, "Puce", numero);
    setListLogs(fetchData);
    setRows(fetchData);
  };
  useEffect(async () => {
    fetchLogsData();
  }, []);
  const columns = [
    { Header: "date", accessor: "dateMouvement", align: "center" },
    { Header: "motif", accessor: "motif", align: "center" },
    { Header: "animal", accessor: "entityItem", align: "center" },
    { Header: "auteur", accessor: "auteur", align: "center" },
    // { Header: "Mise à jour", accessor: "currentValue", align: "center" },
  ];

  return (
    listLogs.length > 0 && (
      <Box
        sx={{ padding: 2, border: "1px solid #ccc", borderRadius: 2, margin: 2 }}
        style={{ backgroundColor: "white" }}
      >
        <ModuleTitle title="Historique d'assignation de la puce à un aimal" />
        <DataTable
          table={{ columns, rows }}
          isSorted={false}
          entriesPerPage
          showTotalEntries
          noEndBorder
          canSearch
          handleSearch={handleSearch}
          refreshData={fetchLogsData}
        />
      </Box>
    )
  );
};

export default PuceLogs;
PuceLogs.propTypes = {
  numero: PropTypes.string.isRequired,
  ApiService: PropTypes.func.isRequired,
};
